var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.shopInfo.template==1)?_c('footer1'):(_vm.$store.getters.shopInfo.template==2)?_c('footer2'):_c('footer0')
}
var staticRenderFns = []

export { render, staticRenderFns }